
import { gql } from "apollo-boost"

export const projectInvoicesReviewed = gql`
mutation setProjectInvoicesReviewed($ids: [String!]!, $reviewed: Boolean!) {
    setProjectInvoicesReviewed(ids: $ids, reviewed: $reviewed)
  }
`